module.exports = function anonymous(locals, escapeFn, include, rethrow
) {
escapeFn = escapeFn || function (markup) {
  return markup == undefined
    ? ''
    : String(markup)
      .replace(_MATCH_HTML, encode_char);
};
var _ENCODE_HTML_RULES = {
      "&": "&amp;"
    , "<": "&lt;"
    , ">": "&gt;"
    , '"': "&#34;"
    , "'": "&#39;"
    }
  , _MATCH_HTML = /[&<>'"]/g;
function encode_char(c) {
  return _ENCODE_HTML_RULES[c] || c;
};
;
  var __output = "";
  function __append(s) { if (s !== undefined && s !== null) __output += s }
  with (locals || {}) {
    ;  var u = require('util/Util.js').default;


// Must round these, but if they don't exist we need to show nothing, not 0. This is for the shared properties when multiple are selected.
var roundedTop
if (top || top === 0) {
    roundedTop = Math.round(top);
}
var roundedLeft
if (left || left === 0) {
    roundedLeft = Math.round(left);
}


    ; __append("\r\n<div class=\"prop-header\"><span class=\"prop-label\">Position</span></div>\r\n<div class=\"nav-position prop-detail\" >\r\n    <div class=\"row nopadding-r\">\r\n        <div class=\"col-md-6 subsection nopadding-r\">\r\n            <label class=\"prop-sublabel label-35\">Top</label>\r\n            <div class=\"col-md-4 nopadding\">\r\n                <input type=\"text\" class=\"numeric\" value=\"")
    ; __append(escapeFn(roundedTop))
    ; __append("\" name=\"top\" id=\"pos_top\"\r\n                        style=\"width:42px; margin-left: 5px; margin-right:5px;\" tabindex=\"30\"/>px\r\n            </div>\r\n        </div>\r\n\r\n        <div class=\"col-md-6 subsection nopadding-r\" name=\"sizeSection\"> \r\n            <label class=\"prop-sublabel label-35\">Width</label>\r\n            <div class=\"col-md-4 nopadding\" name=\"sizeSection\">\r\n                <input type=\"text\" class=\"numeric\" value=\"")
    ; __append(escapeFn(width))
    ; __append("\" name=\"width\" id=\"pos_width\"\r\n                        style=\"width:42px; margin-right:5px;\"  tabindex=\"32\"/>px\r\n            </div>\r\n        </div>\r\n    </div>\r\n\r\n    <div class=\"row\">\r\n        <div class=\"col-md-6 subsection nopadding-r\">\r\n            <label class=\"prop-sublabel label-35\">Left</label>\r\n            <div class=\"col-md-4 nopadding\">\r\n                    <input type=\"text\" class=\"numeric\" value=\"")
    ; __append(escapeFn(roundedLeft))
    ; __append("\" name=\"left\" id=\"pos_left\"\r\n                        style=\"margin-left:5px; margin-right:5px;\" tabindex=\"31\"/>px</div>\r\n        </div>\r\n        \r\n\r\n        <div class=\"col-md-6 subsection nopadding-r\" name=\"sizeSection\">\r\n            <label class=\"prop-sublabel label-35\">Height</label>\r\n            <div class=\"col-md-4 nopadding\" name=\"sizeSection\">\r\n                    <input type=\"text\" class=\"numeric\" value=\"")
    ; __append(escapeFn(height))
    ; __append("\" name=\"height\" id=\"pos_height\"\r\n                        style=\"margin-right:5px;\" tabindex=\"33\"/>px</div>\r\n        </div>\r\n       \r\n    </div>\r\n\r\n    <div class=\"row\">\r\n        <div class=\"col-md-12 subsection nopadding-r\">\r\n            <label class=\"prop-sublabel label-35\">Layer</label>\r\n            <div class=\"col-md-7 nopadding input-group spinner\">\r\n                    <input type=\"text\" class=\"form-control\" value=\"")
    ; __append(escapeFn(zOrder))
    ; __append("\" name=\"zOrder\" id=\"pos_zorder\" tabindex=\"34\" style=\"margin-left:5px;\"/>\r\n                    <div class=\"input-group-btn-vertical\">\r\n                        <button id=\"btn-up\" class=\"btn btn-default\" type=\"button\" style=\"height: 13px;\"><span class=\"fa fa-caret-up\"></span></button>\r\n                        <button id=\"btn-down\" class=\"btn btn-default\" type=\"button\" style=\"height: 12px;\"><span class=\"fa fa-caret-down\"></span></button>\r\n                    </div>\r\n\r\n        </div>\r\n<!--\r\n            <input type=\"number\" value=\"")
    ; __append(escapeFn(zOrder))
    ; __append("\" name=\"zOrder\" id=\"pos_zorder\" tabindex=\"0\"/>\r\n            -->\r\n        </div>\r\n    </div>\r\n</div>")
  }
  return __output;

}